export default function ExposureCardMock() {
  const bars = [
    { label: 'Jan', pct: 12 },
    { label: 'Feb', pct: 0 },
    { label: 'Mar', pct: 38 },
    { label: 'Apr', pct: 22 },
    { label: 'May', pct: 0 },
    { label: 'Jun', pct: 45 },
    { label: 'Jul', pct: 30 },
    { label: 'Aug', pct: 0 },
    { label: 'Sep', pct: 18 },
    { label: 'Oct', pct: 0 },
    { label: 'Nov', pct: 35 },
    { label: 'Dec', pct: 20 },
  ];

  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#06b6d4' }} /> Exposure</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        <div style={{ fontSize: '1rem', fontWeight: 700, color: '#e5e7eb', marginBottom: '0.375rem' }}>
          Minimal Market Presence
        </div>

        {/* Timeline bars */}
        <div style={{ display: 'flex', gap: 2, alignItems: 'flex-end', height: 40, marginBottom: 4 }}>
          {bars.map((b, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{
                width: '100%',
                height: b.pct > 0 ? Math.max(4, b.pct * 0.8) : 0,
                background: b.pct > 0 ? '#06b6d4' : 'transparent',
                borderRadius: 2,
                opacity: 0.7,
              }} />
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.5rem', color: '#4b5563' }}>
          <span>Jan</span><span>Jun</span><span>Dec</span>
        </div>

        <div style={{
          fontSize: '0.5625rem',
          fontWeight: 700,
          color: '#6b7280',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          marginTop: '0.625rem',
        }}>
          Characteristics
        </div>
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', lineHeight: 1.6 }}>
          Direction: Long-only<br />
          Avg position: 4.2d<br />
          Market presence: 18%<br />
          Max gap between trades: 42d
        </div>

        <div style={{
          marginTop: 'auto',
          paddingTop: '0.75rem',
          fontSize: '0.6875rem',
          color: '#6b7280',
          fontStyle: 'italic',
        }}>
          Long gaps between trades — sits in cash most of the time.
        </div>
      </div>
      <div className="platform-mock-caption">
        Exposure shows how often and how long the strategy is actually in the market.
      </div>
    </div>
  );
}
